import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cookie-settings',
  standalone: false,
  templateUrl: './cookie-settings.html',
  styleUrl: './cookie-settings.less'
})
export class CookieSettings {
  constructor(public dialogRef: MatDialogRef<CookieSettings>) {}

  acceptAll() {
    this.dialogRef.close('accept');
  }

  managePreferences() {
    this.dialogRef.close('manage');
  }
}
